import { useRef, useCallback } from 'react'

export function useInfiniteScroll(callback: () => void, isFetching: boolean, hasMore: boolean) {
  const observer = useRef<IntersectionObserver | null>(null)
  
  const lastElementRef = useCallback(
    (node: HTMLElement | null) => {
      if (isFetching || !hasMore) return
      if (observer.current) observer.current.disconnect()
      if (node) {
        observer.current = new IntersectionObserver((entries) => {
          if (entries[0].isIntersecting) callback()
        })
        observer.current.observe(node)
      }
    },
    [callback, isFetching, hasMore]
  )
  
  return lastElementRef
}